import { atom, selector } from 'recoil'

export const modalNewSourceState = atom({
  key: 'SourcesListModalNewSourceState',
  default: false
})

export const modalDeleteState = atom({
  key: 'SourcesListModalDeleteState',
  default: {
    show: false,
    idRow: 0,
    sourceName: undefined
  }
})

export const modalSharedListsState = atom({
  key: 'SourcesListModalSharedListsState',
  default: {
    show: false,
    idRow: undefined,
    lists: [],
    copyToLists: [],
    selectAll: false,
    saving: false
  }
})

export const modalSharedListsValidState = selector({
  key: 'SourcesListModalSharedListsValidState',
  get: ({ get }) => {
    const { selectAll, lists, copyToLists } = get(modalSharedListsState)

    return selectAll ? lists.length > 0 : copyToLists.length > 0
  }
})
